export const AGENT_REGISTRY_FETCH_START = 'agentRegistry/FETCH_START';
export const AGENT_REGISTRY_MERGE = 'agentRegistry/MERGE';
export const AGENT_REGISTRY_CLEAR = 'agentRegistry/CLEAR';
